import { useEffect, useState } from 'react';
import {
  MenuAvatarCircle,
  ProfileAvatarCircle,
} from '../../assets/styles/components/settingsPopover.styled';

interface UserAvatarCircleProps {
  imageUrl?: string | null;
  fullName?: string;
  isProfileSize?: boolean;
  className?: string;
}

const resolveInitials = (fullName?: string) => {
  const words = fullName?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (!words.length) return '';
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
};

const UserAvatarCircle = ({
  imageUrl,
  fullName,
  isProfileSize = false,
  className = '',
}: UserAvatarCircleProps) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  const showImage = !!imageUrl && !imageFailed;
  const AvatarCircle = isProfileSize ? ProfileAvatarCircle : MenuAvatarCircle;

  return (
    <AvatarCircle data-testid="user-avatar-circle" className={className}>
      {showImage ? (
        <img
          src={imageUrl as string}
          alt={fullName ? `${fullName} avatar` : 'User avatar'}
          onError={() => setImageFailed(true)}
        />
      ) : (
        resolveInitials(fullName)
      )}
    </AvatarCircle>
  );
};

export default UserAvatarCircle;
